import React from "react";

export function EventContentSkeleton(props: { rowCount?: number }) {
	let rows = props.rowCount || 3;
	return (
		<div className="skeleton">
			<div className="skeleton__list skeleton__list--flex">
				{new Array(rows).fill(0).map((_, idx) => (
					<div
						key={idx}
						className="skeleton__box skeleton--item__match--fixed"
					/>
				))}
			</div>
		</div>
	);
}
